import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1080.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)" >
<path d="M5290 10033 c-1168 -43 -2245 -505 -3076 -1319 -640 -628 -1087
-1444 -1274 -2330 -246 -1167 -29 -2377 608 -3394 299 -476 704 -913 1162
-1252 959 -709 2176 -1019 3355 -853 1272 179 2380 850 3122 1892 664 933 957
2097 812 3233 -49 385 -149 779 -287 1125 -46 115 -147 336 -193 422 -116 215
-118 219 -237 403 -276 425 -675 849 -1097 1164 -629 471 -1390 777 -2175 875
-165 21 -500 43 -595 39 -27 -1 -84 -3 -125 -5z m510 -493 c334 -30 704 -115
1045 -240 636 -233 1219 -630 1653 -1125 53 -60 99 -112 102 -115 3 -3 21 -25
41 -50 154 -194 275 -373 384 -567 711 -1271 711 -2815 -1 -4080 -185 -329
-387 -597 -658 -871 -333 -339 -663 -582 -1075 -791 -441 -224 -879 -358
-1399 -428 -184 -25 -803 -25 -982 0 -599 83 -1095 248 -1579 525 -756 433
-1370 1113 -1721 1907 -181 407 -273 745 -342 1245 -20 152 -17 781 5 940 40
286 93 533 160 745 238 751 644 1374 1232 1894 499 440 1089 747 1753 910 247
61 468 94 762 115 92 6 497 -3 620 -14z"/>
<path d="M5140 9503 c-611 -36 -1268 -237 -1805 -551 -321 -189 -556 -371
-830 -646 -346 -347 -575 -663 -784 -1084 -433 -872 -540 -1879 -300 -2827
192 -753 589 -1436 1143 -1959 403 -382 816 -649 1313 -847 984 -392 2047
-393 3053 0 129 50 419 192 549 268 452 265 887 652 1199 1067 442 585 709
1247 804 1989 32 253 32 714 0 976 -83 670 -322 1301 -701 1851 -258 376 -665
783 -1041 1042 -601 414 -1314 664 -2045 718 -129 9 -423 11 -555 3z m-434
-2433 c79 -173 157 -342 172 -375 15 -32 108 -235 207 -450 l180 -390 503 -3
c276 -1 502 -6 502 -10 0 -4 -147 -125 -326 -267 -179 -143 -338 -270 -352
-282 -15 -11 -151 -120 -302 -240 -151 -121 -555 -443 -898 -717 -343 -274
-626 -496 -628 -493 -2 2 119 251 269 553 151 302 297 596 326 654 l52 105
179 155 c99 85 180 161 180 168 0 18 -241 542 -249 542 -8 0 -21 -25 -218
-410 -80 -157 -178 -348 -218 -425 -40 -77 -121 -234 -180 -350 -59 -115 -145
-282 -190 -370 -45 -88 -155 -302 -243 -475 -89 -173 -180 -351 -204 -395
l-43 -80 -333 -3 c-242 -2 -332 1 -332 9 0 6 40 89 89 183 49 94 137 266 196
381 59 116 147 287 195 380 48 94 142 278 210 410 67 132 157 308 200 390 43
83 133 258 200 390 68 132 198 386 290 565 92 179 225 438 295 575 104 204
249 485 297 578 5 10 14 17 19 15 5 -2 75 -145 155 -318z m2194 246 c260 -4
286 -8 432 -62 63 -24 202 -104 257 -149 172 -140 290 -317 352 -531 29 -100
31 -122 32 -264 1 -155 -15 -260 -54 -355 -7 -16 -13 -32 -14 -35 -6 -27 -56
-120 -95 -181 -28 -41 -50 -80 -50 -85 0 -5 22 -26 48 -47 150 -114 306 -341
370 -537 143 -436 27 -902 -302 -1218 -191 -183 -424 -293 -686 -322 -61 -7
-345 -10 -804 -8 l-708 3 -160 315 c-222 438 -222 437 -200 455 9 8 58 46 107
85 50 39 97 76 105 83 28 22 105 82 115 89 6 4 28 22 50 41 53 44 105 80 110
75 3 -3 39 -79 107 -228 11 -25 41 -88 65 -140 25 -52 54 -114 64 -137 l18
-43 539 0 c595 0 591 0 731 65 144 68 270 237 302 403 15 82 6 219 -21 296
-59 172 -196 307 -369 364 -74 24 -84 25 -451 29 -206 3 -376 6 -377 7 -1 1
130 136 291 299 204 206 300 297 315 297 37 0 134 39 181 72 66 47 98 85 136
163 57 117 57 251 1 375 -40 86 -167 194 -261 221 -32 9 -1005 14 -1014 5 -3
-3 14 -48 36 -99 23 -52 44 -101 48 -110 6 -16 -21 -17 -319 -17 l-326 0 -22
48 c-37 81 -130 294 -155 354 -13 31 -36 85 -52 120 -16 35 -35 79 -42 98 -7
19 -17 40 -22 46 -7 10 -68 152 -68 160 0 9 1135 10 1760 0z m-3896 -4205 c25
-60 46 -111 46 -115 0 -3 -13 -6 -29 -6 -20 0 -30 6 -34 20 -4 17 -14 20 -60
20 -47 0 -57 -3 -62 -20 -4 -14 -15 -20 -35 -20 l-29 0 41 98 c55 132 54 132
87 132 27 0 32 -6 75 -109z m436 94 c34 -17 39 -48 14 -76 -14 -16 -14 -19 5
-38 28 -28 26 -55 -6 -81 -23 -18 -38 -20 -102 -18 l-75 3 2 110 c1 61 2 111
2 113 1 10 137 -1 160 -13z m320 -64 c0 -101 24 -131 81 -101 16 9 19 22 19
95 l0 85 28 0 c29 0 29 0 31 -69 2 -77 -15 -133 -47 -150 -12 -6 -41 -11 -67
-11 -37 0 -51 5 -70 26 -23 24 -25 35 -25 115 0 88 0 89 25 89 25 0 25 -1 25
-79z m545 69 c67 -25 93 -96 60 -160 -23 -45 -64 -61 -143 -58 l-67 3 -3 99
c-1 55 0 106 2 113 6 16 111 18 151 3z m468 -97 c26 -60 47 -111 47 -115 0 -5
-13 -8 -29 -8 -20 0 -30 6 -34 20 -4 17 -14 20 -60 20 -47 0 -57 -3 -62 -20
-4 -14 -15 -20 -35 -20 -33 0 -34 -3 15 105 15 33 33 75 41 93 11 25 20 32 42
32 27 0 32 -7 75 -107z m436 93 c67 -35 82 -122 32 -178 -28 -31 -33 -33 -110
-36 l-81 -4 0 116 0 116 65 0 c38 0 78 -6 94 -14z m416 4 c4 -6 26 -58 50
-115 l43 -105 -27 0 c-15 0 -31 8 -39 20 -10 16 -23 20 -66 20 -45 0 -54 -3
-59 -20 -3 -14 -14 -20 -31 -20 -14 0 -26 3 -26 6 0 4 21 55 46 115 44 102 49
109 75 109 15 0 31 -5 34 -10z m465 -9 c0 -15 -8 -21 -32 -23 l-33 -3 -3 -92
c-3 -91 -3 -93 -27 -93 -24 0 -24 2 -27 93 l-3 92 -32 3 c-25 2 -33 8 -33 23
0 17 8 19 95 19 87 0 95 -2 95 -19z m379 -98 l49 -113 -29 0 c-18 0 -32 7 -39
20 -9 16 -21 20 -65 20 -45 0 -55 -3 -60 -20 -4 -14 -15 -20 -35 -20 l-28 0
37 88 c65 149 61 143 94 140 26 -3 32 -12 76 -115z m428 104 c18 -10 19 -15 9
-29 -10 -14 -18 -15 -54 -5 -31 8 -45 8 -54 -1 -16 -16 5 -38 46 -46 69 -13
98 -75 54 -116 -20 -18 -32 -21 -84 -18 -72 4 -99 20 -83 49 9 18 12 18 40 3
40 -20 84 -15 84 10 0 14 -12 23 -47 33 -45 13 -78 43 -78 71 0 7 11 24 25 37
19 20 34 25 72 25 26 -1 58 -6 70 -13z m293 -60 c0 -78 16 -117 50 -117 38 0
50 27 50 111 l0 79 31 0 31 0 -4 -90 c-3 -101 -18 -126 -79 -139 -49 -10 -74
-3 -103 26 -24 24 -26 32 -26 114 0 88 0 89 25 89 24 0 25 -2 25 -73z m576 48
c19 -25 18 -50 -2 -70 -15 -15 -15 -18 5 -36 11 -11 21 -27 21 -37 -1 -43 -39
-62 -129 -62 l-71 0 0 116 0 116 81 -4 c66 -3 83 -7 95 -23z"/>
<path d="M2905 3118 c-16 -40 -12 -48 27 -48 23 0 29 4 24 16 -3 9 -9 27 -12
40 -8 33 -22 30 -39 -8z"/>
<path d="M3330 3150 c0 -27 3 -30 29 -30 16 0 37 7 46 16 22 23 2 44 -41 44
-31 0 -34 -3 -34 -30z"/>
<path d="M3334 3081 c-2 -2 -4 -15 -4 -28 0 -22 3 -24 43 -21 34 2 43 7 45 24
3 19 -3 22 -38 26 -23 2 -43 2 -46 -1z"/>
<path d="M4210 3106 l0 -76 35 0 c45 0 75 29 75 73 0 47 -19 67 -68 74 l-42 6
0 -77z"/>
<path d="M4678 3121 c-9 -22 -13 -42 -10 -45 9 -9 62 -7 62 3 0 11 -29 81 -34
81 -1 0 -10 -18 -18 -39z"/>
<path d="M5110 3178 c-1 -2 -2 -36 -3 -76 l-2 -72 30 0 c40 0 71 23 78 57 6
32 -14 78 -38 87 -16 6 -65 9 -65 4z"/>
<path d="M5576 3128 c-22 -51 -20 -58 14 -58 33 0 35 7 15 60 l-13 35 -16 -37z"/>
<path d="M6368 3121 c-9 -22 -13 -42 -10 -45 9 -9 62 -7 62 3 0 11 -29 81 -34
81 -1 0 -10 -18 -18 -39z"/>
<path d="M7644 3165 c-10 -26 4 -45 34 -45 37 0 54 17 41 42 -12 22 -67 25
-75 3z"/>
<path d="M7640 3054 c0 -23 3 -25 43 -22 35 2 43 7 45 26 3 20 -1 22 -42 22
-43 0 -46 -2 -46 -26z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
